import { Route, Routes } from "react-router";
import { useSession } from "./lib/session";
import SignedOut from "./components/SignedOut";
import AppShell from "./components/AppShell";
import Home from "./routes/Home";
import Companies from "./routes/Companies";
import Jobs from "./routes/Jobs";
import Runs from "./routes/Runs";
import Applications from "./routes/Applications";
import Resumes from "./routes/Resumes";
import Corpus from "./routes/Corpus";
import ResumeTailor from "./routes/ResumeTailor";
import CoverLetters from "./routes/CoverLetters";
import Insights from "./routes/Insights";
import Settings from "./routes/Settings";
import Profile from "./routes/Profile";
import ProfileLocation from "./routes/ProfileLocation";
import ApplicationAssistant from "./routes/ApplicationAssistant";
import ApplyKit from "./routes/ApplyKit";
import { ReviewDetail, ReviewList } from "./routes/Review";
import InterviewPrep from "./routes/InterviewPrep";
import Contacts from "./routes/Contacts";
import Templates from "./routes/Templates";
import Dlq from "./routes/Dlq";
import { Spinner } from "./components/ui/Spinner";

export default function App() {
  const session = useSession();

  if (session.isLoading) {
    return (
      <main className="grid min-h-dvh place-items-center bg-neutral-950 text-neutral-500">
        <Spinner size={20} />
      </main>
    );
  }
  if (!session.data) return <SignedOut />;

  const user = session.data;
  return (
    <AppShell user={user}>
      <Routes>
        <Route path="/" element={<Home user={user} />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/review" element={<ReviewList />} />
        <Route path="/review/:applicationId" element={<ReviewDetail />} />
        <Route path="/resumes" element={<Resumes />} />
        <Route path="/corpus" element={<Corpus />} />
        <Route
          path="/applications/:applicationId/resume"
          element={<ResumeTailor />}
        />
        <Route
          path="/applications/:applicationId/apply"
          element={<ApplicationAssistant />}
        />
        <Route
          path="/applications/:applicationId/apply-kit"
          element={<ApplyKit />}
        />
        <Route
          path="/applications/:applicationId/kit"
          element={<ApplyKit />}
        />
        <Route
          path="/applications/:applicationId/prep"
          element={<InterviewPrep />}
        />
        <Route
          path="/jobs/:companyId/:jobId/tailor"
          element={<ResumeTailor />}
        />
        <Route path="/cover-letters" element={<CoverLetters />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/runs" element={<Runs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/location" element={<ProfileLocation />} />
        {user.is_admin ? <Route path="/dlq" element={<Dlq />} /> : null}
      </Routes>
    </AppShell>
  );
}
